import { Component, inject, OnInit } from '@angular/core';
import { TemplateBaseButtonIconComponent } from '../../shared/components/button/button';
import { InstitutionalSignatureComponent } from '../../shared/components/institutional-signature/institutional-signature.component';
import { ButtonTypeEnum } from '../../shared/enums/button-type.enum';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  imports: [TemplateBaseButtonIconComponent, InstitutionalSignatureComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  private router: Router = inject(Router);
  authService: AuthService = inject(AuthService);
  isRedirecting = false;
  mensagemEncerramento: string | null = null;
  protected readonly ButtonType = ButtonTypeEnum;

  ngOnInit(): void {
    this.mensagemEncerramento =
      this.authService.consumirMotivoEncerramento() === 'inatividade'
        ? 'Sua sessão foi encerrada por inatividade. Entre novamente para continuar.'
        : null;

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
      return;
    }
  }

  /** Redireciona o usuário ao Keycloak para autenticação (Authorization Code + PKCE). */
  login(): void {
    if (this.isRedirecting) {
      return;
    }

    this.isRedirecting = true;
    this.authService.loginRedirect();
  }
}
